'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.base64EncodeParams = exports.formatUrlParams = exports.splitOnDelimiter = exports.isParamsObject = exports.parseUrlParams = exports.isEqual = exports.isUuid = exports.isURL = exports.paramsSerializer = exports.getShortName = exports.getUID = exports.dataSource = exports.isEmpty = exports.required = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _keys = require('lodash/keys');

var _keys2 = _interopRequireDefault(_keys);

var _jsBase = require('js-base64');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var required = exports.required = function required() {
  throw new Error('Required parameter not supplied');
};

var isEmpty = exports.isEmpty = function isEmpty(val) {
  if (Array.isArray(val)) {
    return val.length === 0;
  } else {
    return !val;
  }
};

var dataSource = exports.dataSource = function dataSource(_ref) {
  var event = _ref.event,
      charity = _ref.charity,
      campaign = _ref.campaign;

  if (!isEmpty(event)) {
    if (isNaN(event) && isNaN(event.uid) && !Array.isArray(event)) {
      throw new Error('Event parameter must be an ID or an array');
    }

    return 'event';
  } else if (!isEmpty(charity) && isEmpty(campaign)) {
    return 'charity';
  } else if (!isEmpty(campaign)) {
    return 'campaign';
  } else {
    return required();
  }
};

var getUID = exports.getUID = function getUID(data) {
  switch (typeof data === 'undefined' ? 'undefined' : _typeof(data)) {
    case 'object':
      return Array.isArray(data) ? getUID(data[0]) : data.uid;
    default:
      return data;
  }
};

var getShortName = exports.getShortName = function getShortName(data) {
  return (typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object' ? data.shortName : data;
};

var paramsSerializer = exports.paramsSerializer = function paramsSerializer(params) {
  return (0, _keys2.default)(params).map(function (key) {
    var value = params[key];

    if (!value) return false;

    if (Array.isArray(value)) {
      return value.map(function (val) {
        return [key, val].join('=');
      }).join('&');
    }

    return [key, value].join('=');
  }).filter(Boolean).join('&');
};

var isURL = exports.isURL = function isURL(str) {
  var urlRegex = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-/]))?/;
  return urlRegex.test(str);
};

var isUuid = exports.isUuid = function isUuid(string) {
  var uuidRegex = /^[0-9a-f]{8}-?[0-9a-f]{4}-?[0-5][0-9a-f]{3}-?[089ab][0-9a-f]{3}-?[0-9a-f]{12}$/i;
  return uuidRegex.test(string);
};

var isEqual = exports.isEqual = function isEqual(a, b) {
  return String(a) === String(b);
};

var parseUrlParams = exports.parseUrlParams = function parseUrlParams() {
  if (typeof window === 'undefined') {
    return {};
  }

  var paramsArray = ['search', 'hash'].map(function (param) {
    return window.location[param].substring(1);
  }).filter(Boolean).join('&').split('&');

  return paramsArray.reduce(function (params, part) {
    var _part$split = part.split('='),
        _part$split2 = _slicedToArray(_part$split, 2),
        key = _part$split2[0],
        val = _part$split2[1];

    params[decodeURIComponent(key)] = decodeURIComponent(val);
    return params;
  }, {});
};

var isParamsObject = exports.isParamsObject = function isParamsObject(args) {
  return args.length === 1 && _typeof(args[0]) === 'object' && !Array.isArray(args[0]);
};

var splitOnDelimiter = exports.splitOnDelimiter = function splitOnDelimiter(param) {
  var delimeter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ',';
  return typeof param === 'string' ? param.split(delimeter) : param;
};

var formatUrlParams = exports.formatUrlParams = function formatUrlParams(params, encode) {
  return Object.keys(params).filter(function (key) {
    return !!params[key];
  }).map(function (key) {
    return key + '=' + (encode ? encodeURIComponent(params[key]) : params[key]);
  }).join('&');
};

var base64EncodeParams = exports.base64EncodeParams = function base64EncodeParams(params) {
  var result = Object.keys(params).filter(function (key) {
    return !!params[key];
  }).reduce(function (result, key) {
    return _extends({}, result, _defineProperty({}, key, params[key]));
  }, {});
  return _jsBase.Base64.encode(JSON.stringify(result));
};